/**
 * FAQ data for different pages
 */

import { liveLanguagesPhrase, liveScriptsPhrase } from './languages';

export const homeFaqs = [
  {
    q: "What is Bhol?",
    a: "Bhol is an app for learning Indian languages through short lessons, useful vocabulary, pronunciation practice, and real conversations."
  },
  {
    q: "Which languages does Bhol teach?",
    a: `Bhol currently teaches ${liveLanguagesPhrase}. Each course focuses on practical language you can use in everyday conversation.`
  },
  {
    q: "Where can I download Bhol?",
    a: "Bhol is available on the Apple App Store. Tap any App Store badge on this site to download it."
  },
  {
    q: "Can I use Bhol as a complete beginner?",
    a: "Yes. Start with greetings and short sentences written in English letters. You can also use Bhol to practise a language you grew up hearing."
  },
  {
    q: "Do I need to read native script?",
    a: `No. Every course writes words in English letters, so you can start speaking while seeing native script (${liveScriptsPhrase}) alongside the meaning.`
  },
  {
    q: "What will I practice in Bhol?",
    a: "You will review words, practise pronunciation, and use what you learn in conversations about everyday situations."
  }
];

export const supportFaqs = [
  {
    q: "How do I reset my password?",
    a: "Use the sign-in flow in the iOS app. If you still cannot access your account, contact us through the support form below."
  },
  {
    q: "How do I download Bhol?",
    a: "Use any App Store badge on this site, or search for Bhol in the Apple App Store."
  },
  {
    q: "Which languages does Bhol support?",
    a: `Bhol currently supports ${liveLanguagesPhrase}. Tell us which language you want next through the support form.`
  },
  {
    q: "Which devices will Bhol support?",
    a: "Bhol is currently built for iPhone. If you want Android support, send us a note so we can track demand."
  },
  {
    q: "How can I provide feedback or report a bug?",
    a: "Use the contact form below to send us your feedback, bug reports, or feature suggestions. We read every message and appreciate your input!"
  },
  {
    q: "How do I contact the Bhol team?",
    a: "You can reach us using the contact form below, or email us directly at help@bhol.app. We typically respond within 24-48 hours."
  }
];
